import { render } from "./bookingConfirmed.vue?vue&type=template&id=3554118a"
import script from "./bookingConfirmed.vue?vue&type=script&lang=js"
export * from "./bookingConfirmed.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__